<template>
    <div class="QHImgUpload">
        <div class="list">
            <div class="li flex-center" v-for="(item, index) in values" v-bind:key="index">
                <img :src="$httpImg(item.url)">
                <div class="tool flex-center">
                    <Icon type="ios-eye-outline" size="30" @click="$openImg(item.url, item.name)" />
                    <Icon type="ios-trash-outline" size="30" @click="remove(index)" />
                </div>
            </div>
        </div>
        <Upload :action="action" :on-success="success" :on-error="error" :on-remove="stop"
            :on-format-error="formatError" :format="format" accept="image/*" :max-size="size"
            :on-exceeded-size="exceededSize" :show-upload-list="false" :before-upload="before" :headers="headers"
            ref="upload" v-if="max > values.length">
            <div class="uploadImgBtn flex-center">
                <div>
                    <Icon type="md-cloud-upload" size="40"></Icon>
                </div>
            </div>
        </Upload>
    </div>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            loading: false,
            action: this.$config.api + '/os/Uploads/uploadFile',
            headers: {
                'token': localStorage.getItem('token')
            },
            values: [],
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: [Array, String],
            default: () => {
                return [];
            }
        },
        format: {
            type: Array,
            default: ['jpg', 'jpeg', 'png']
        },
        max: {
            type: Number,
            default: 3
        },
        size: {
            type: Number,
            default: 2048
        }
    },


    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        setValue() {
            this.values = this.value || [];
        },
        getValue() {
            this.$emit('input', this.values);
        },
        before() {
            this.loading = true;
            this.$loading(true, '正在上传')
        },
        success(response) {
            this.loading = false;
            this.$loading(false)
            this.$msg('上传成功', 'success');
            this.$refs.upload.fileList = [];
            if (response.code == 0) {
                this.values.push(response.data);
                this.getValue();
            } else {
                this.$msg(response.msg, "error");
            };
        },
        error() {
            this.loading = false;
            this.$loading(false)
            this.$msg("上传失败：未知错误", "error");
            this.$refs.upload.fileList = [];
        },
        remove(index) {
            this.values.shift(index, 1);
            this.setValue();
        },
        stop() {
            this.loading = false;
            this.$loading(false)
            this.$refs.upload.fileList = [];
        },
        formatError() {
            this.loading = false;
            this.$loading(false)
            this.$refs.upload.fileList = [];
            this.$msg("文件格式错误:只能是" + this.format.join(","), "error");
        },
        exceededSize() {
            this.loading = false;
            this.$loading(false)
            this.$refs.upload.fileList = [];
            this.$msg("文件大小超限:不能超过" + this.size + "kb", "error");
        },
    }
}
</script>
<style>
.QHImgUpload .uploadImgBtn {
    width: 100px;
    height: 100px;
    border: 1px dashed #ccc;
    cursor: pointer;
    box-sizing: border-box;

}

.QHImgUpload .ivu-progress {
    position: absolute;
    left: 5px;
    bottom: 5px;
    width: 90px;
    z-index: 1;
}

.QHImgUpload .ivu-upload {
    display: inline-block;
    position: relative;
}

.QHImgUpload .list {
    float: left;
}

.QHImgUpload .list .li {
    width: 100px;
    height: 100px;
    float: left;
    background: #eee;
    margin-right: 10px;
    background: #e8eaec;
    position: relative;
}

.QHImgUpload .list .li .tool {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(0, 0, 0, 0.6);
    color: rgba(255, 255, 255, 0.8);
    display: none;
}

.QHImgUpload .list .li:hover .tool {
    display: flex;
}

.QHImgUpload .list .li .tool .ivu-icon:hover {
    color: #fff;
    cursor: pointer;
}

.QHImgUpload .list .li img {
    cursor: pointer;
    display: block;
    max-width: 100px;
    max-height: 100px;
    margin: 0;
}
</style>